import './app.scss';

BX.Vue.component('bx-financial-advisor-benefits', {
  data: function () {
    return {
      title: this.$parent.SECTION.NAME,
      description: this.$parent.SECTION.DESCRIPTION,
      list: this.$parent.ITEMS,
      theme: this.$parent?.THEME?.length ? this.$parent.THEME : 'dark',
    };
  },
  template: `
          <section class="financial-advisor-benefits" :data-theme="theme" data-section-num="3">
              <div class="container-2024 grid-2024 -sticky">
                <div class="financial-advisor-benefits__header g-col-lg-6 g-start-lg-4 g-col-full">
                  <h2 class="financial-advisor-benefits__title animate" v-html="title"></h2>
                </div>
                <div class="financial-advisor-benefits__content g-col-lg-6 g-start-lg-4 g-col-full">
                  <p v-if="description" v-html="description"></p>
                  <div v-if="list.length" class="financial-advisor-benefits__list financial-advisor-benefits__list--accordion">
                    <details v-for="(item, index) in list" :key="index" class="financial-advisor-benefits__item animate">
                      <summary class="financial-advisor-benefits__item-title" v-html="item.NAME"></summary>
                      <div class="financial-advisor-benefits__item-description" v-html="item.PREVIEW_TEXT"></div>
                    </details>
                  </div>
                  <a href="/rates" class="financial-advisor-benefits__btn button-2024">Тарифы</a>
                </div>
              </div>
          </section>
        `,
});
